// eslint-disable-next-line no-unused-vars
import * as React from "react";
import styled from "@emotion/styled";
import { Typography } from "@mui/material";

export const Label = styled.div`
    margin-bottom: 0.5rem;
`;

export const Error = styled(Typography)`
    margin: 0 0 -1.21875rem 1rem;
`;